
// The "Stickman" Source Image
export const ARTIFACT_URL = "https://res.cloudinary.com/dzwotlelh/image/upload/v1765219287/unnamed_zqy4vw.png";

export const LOADING_MESSAGES = [
  "ignoring wojak's calls...",
  "buying another jpeg...",
  "styling my pink hair...",
  "booking the vip table...",
  "laughing at poor people...",
  "checking the charts (up only)...",
  "being genuine but insensitive...",
  "chasing the thrill...",
  "getting away with it..."
];

export const NAV_ITEMS = [
  { name: 'the_life', path: '/' },
  { name: 'money_printer', path: '/forge' },
  { name: 'fake_id', path: '/pfp' },
  { name: 'vip_lounge', path: '/board' },
  { name: 'tax_evasion', path: '/dojo' },
];
